import styled from "styled-components";

export const Wrapper = styled.div``;

export const Title = styled.h2`
    padding-top: 4rem;
    font-family: 'Rubik';
    font-size: 18px;
    font-weight: 600;
`;

export const Header = styled.thead`
    margin-top: 3rem;
    border-radius: 12px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    background-color: #d1e5ff;
    font-family: 'Rubik';
    font-size: 18px;
    font-weight: 600;
    color: #141823;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
`;

export const RouteColumn = styled.td`
    width: 34%;
    display: flex;
    align-items: center;
`;

export const RouteImageWrapper = styled.img`
    width: 80px;
    height: 46px;
    margin-left: 16px;
`;

export const RouteColumnWrapper = styled.div`
    padding-left: 18px;
`;

export const FareColumn = styled.td`
    width: 34%;
    display: flex;
`;

export const IconWrapper = styled.div`
    margin-right: 10px;
    width: 16px;
    flex: 0 0 16px;
`;

export const FareWrapper = styled.div``;

export const PriceColumn = styled.td`
    width: 10%;
`;
export const PriceColumnHeading = styled.td`
    width: 10%;
    display:contents;
`;
export const CTAColumn = styled.td`
    text-align: end;
    width: 20%;
`;

export const BodyWrapper = styled.tbody`
    padding: 0 18px 0 24px;
    background-color: #fff;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
`;

export const TableRow = styled.tr`
    width: 100%;
    display: flex;
`;

export const Table = styled.table`
    width: 100%;
`;

export const Body = styled.tr`
    padding: 24px 0 20px 0;
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #eaeaea;

    &:last-child {
        border-bottom: 0;
    }
`;

export const BodyTitle = styled.p`
    font-family: 'Rubik';
    font-size: 16px;
    font-weight: 600;
`;

export const BodySubTitle = styled.p`
    color: #4f525a;
`;

export const PriceWrapper = styled.div`
    font-size: 22px;
    font-weight: 600;
`;

export const LPGWrapper = styled.div`
    font-size: 12px;
    padding-top: 4px;
`;

export const LPGTitle = styled.span`
    color: #2bac36;
`;

export const ToolTipWrapper = styled.div`
    position: absolute;
    left: 0;
    top: 0;
`;

export const LPGSubTitle = styled.span`
    color: #2276e3;
    position: relative;
    font-weight: 600;
`;

export const HrPackageCard = styled.div`
  border-radius: 1.2rem;
  background-color: #ffffff;
  padding: 4px 10px;
  margin-top: 3rem;
`